// extracted by mini-css-extract-plugin
module.exports = {"root":"_33ARy","item":"_1F-rG"};